'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _identify2 = require('./utils/identify');

var _identify3 = _interopRequireDefault(_identify2);

var _traits = require('./traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_EMAIL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CREATED_AT, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number])), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACINGPOST_CONTACT, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_THIRDPARTY_CONTACT, _propTypes3.default.string.isRequired), _propTypes);
/**
 *
 * @param traits
 * @returns Object {} with tracking params
 */
function identifyRegister() {
    var _identify;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // eslint-disable-next-line no-console
    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', identifyRegister.displayName + ' method');
    return (0, _identify3.default)((_identify = {}, (0, _defineProperty3.default)(_identify, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_identify, _traits.TRAIT_CREATED_AT, traits[_traits.TRAIT_CREATED_AT] || Date.now()), (0, _defineProperty3.default)(_identify, _traits.TRAIT_RACINGPOST_CONTACT, traits[_traits.TRAIT_RACINGPOST_CONTACT]), (0, _defineProperty3.default)(_identify, _traits.TRAIT_THIRDPARTY_CONTACT, traits[_traits.TRAIT_THIRDPARTY_CONTACT]), _identify));
}

identifyRegister.displayName = 'identifyRegister';

exports.default = identifyRegister;


//////////////////
// WEBPACK FOOTER
// ./~/rp-betting-special-offer/~/rp-analytics/lib/identifyRegister.js
// module id = 2569
// module chunks = 0